import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

interface ScrollToTopLayoutProps {
    children: React.ReactNode;
    smooth?: boolean;
}

/**
 * Tüm sayfalarda otomatik olarak en üste scroll yapan layout component 
 * Hem path hem de query parameter değişimlerini yakalar
 */
export const ScrollToTopLayout: React.FC<ScrollToTopLayoutProps> = ({
    children,
    smooth = true
}) => {
    const location = useLocation();
    const prevLocationRef = useRef(location);

    useEffect(() => {
        // Sadece gerçekten location değiştiğinde scroll yap
        if (prevLocationRef.current !== location) {
            prevLocationRef.current = location;

            const scrollToTop = () => {
                // Farklı scroll yöntemlerini dene
                try {
                    // Yöntem 1: document.documentElement (daha güvenilir)
                    if (document.documentElement) {
                        document.documentElement.scrollTop = 0;
                        document.documentElement.scrollLeft = 0;
                    }

                    // Yöntem 2: window.scrollTo (fallback)
                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: smooth ? 'smooth' : 'auto'
                    });

                    // Yöntem 3: document.body (eski tarayıcılar için)
                    if (document.body) {
                        document.body.scrollTop = 0;
                        document.body.scrollLeft = 0;
                    }
                } catch (error) {
                    console.warn('Scroll to top failed:', error);
                }
            };

            // Hemen scroll yap
            scrollToTop();

            // Sayfa yüklendikten sonra tekrar dene
            const timer1 = setTimeout(scrollToTop, 50);
            const timer2 = setTimeout(scrollToTop, 200);
            const timer3 = setTimeout(scrollToTop, 500);

            return () => {
                clearTimeout(timer1);
                clearTimeout(timer2);
                clearTimeout(timer3);
            };
        }
    }, [location, smooth]);

    return <>{children}</>;
};
